import { createReducer, on } from '@ngrx/store';

import { Tabs } from '../dashboard/components/overview/models/overview.model';
import * as offerActions from '../offer/store/actions/offer.actions';
import * as requestActions from '../request/store/actions/request.actions';
import { AppState } from '../shared/models';
import { ManureFilters } from '../shared/models/manure-filters.model';

export const initialAppState = (): AppState => ({
  overviewState: {
    selectionButton: 'offers',
    totalNumberOfOffers: 0,
    status: 'loading',
    offerPageAndSize: {
      pageIndex: 0,
      pageSize: 25,
    },
    requestsPageAndSize: {
      pageIndex: 0,
      pageSize: 25,
    },
    currentTab: Tabs.manureOffers,
    totalNumberOfRequests: 0,
    filters: {} as ManureFilters,
    overviewOffersLoading: false,
    overviewRequestsLoading: false,
  },
  lastSuccessfulManureOfferPost: null,
  lastSuccessfulManureRequestPost: null,
});

export const manureReducer = createReducer<AppState>(
  initialAppState(),
  on(offerActions.sendManureOfferSuccess, (state, { response }) => {
    return {
      ...state,
      lastSuccessfulManureOfferPost: response,
    };
  }),
  on(requestActions.sendManureRequestSuccess, (state, { response }) => {
    return {
      ...state,
      lastSuccessfulManureRequestPost: response,
    };
  }),
);

export const appReducer = createReducer<AppState>(initialAppState());
